<template>
  <div class="page-container">
    <div class="backbtn-container">
      <router-link to="/my-office">
        <div class="back-btn mr-3">
          <v-icon class="pointer-events-none">mdi-arrow-left</v-icon>
        </div>
      </router-link>
      <span class="p-0">{{ this.productData?.name }}</span>
    </div>
    <div class="wrappers">
      <ValidationObserver ref="observerproduct">
        <form @submit.prevent="submitFormProductCreate">
          <div class="main-container">
            <div class="w-50">
              <div class="Field">
                <span class="title">{{ this.$t("name") }}</span>
                <div class="text-field">
                  <span class="label">{{ this.$t("productName") }}</span>
                  <ValidationProvider
                    :name="this.$t('productName')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      v-model="productData.name"
                      placeholder="-"
                      :class="{ errorInput: !!errors[0] }"
                      style="width: 100%"
                    />
                    <span class="error-text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="Field">
                <span class="title">{{
                  this.$t("productCharacteristics")
                }}</span>
                <div class="text-field">
                  <span class="label">{{ this.$t("description") }}</span>
                  <ValidationProvider
                    :name="this.$t('description')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <textarea
                      style="width: 100%"
                      :class="{ errorInput: !!errors[0] }"
                      v-model="productData.description"
                    ></textarea>
                    <span class="error-text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="text-field">
                  <span class="label">{{ this.$t("quantityProducts") }}</span>
                  <ValidationProvider
                    :name="this.$t('quantityProducts')"
                    rules="required|numeric"
                    v-slot="{ errors }"
                  >
                    <input
                      type="number"
                      min="1"
                      v-model="productData.totalCount"
                      style="width: 100%"
                      placeholder="-"
                      :class="{ errorInput: !!errors[0] }"
                    />
                    <span class="error-text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="Field">
                <span class="title">{{ this.$t("categoryProduct") }}</span>
                <div class="text-field">
                  <span class="label">{{ this.$t("category") }}</span>
                  <!-- Add ValidationProvider for category if needed -->
                  <ValidationProvider
                    rules="required"
                    :name="this.$t('category')"
                    v-slot="{ errors }"
                  >
                    <div class="category_container">
                      <vue-select
                        :class="{ errorSelect: !!errors[0] }"
                        ref="ProductSelectRef"
                        infinite
                        :name="$t('measure')"
                        @changeText="debouncedCategorySearchByName"
                        @changeText2="setSearchValue"
                        @input="clearSelectedCategory"
                        v-model="productData.categoryId"
                        :items="categoryList"
                        clearable
                        :itemText="`name_${$i18n.locale}`"
                        class="user_input no-margin"
                        style="flex-grow: 1"
                      ></vue-select>
                      <button
                        type="button"
                        class="btn add"
                        @click="dialog = true"
                      >
                        +
                      </button>
                    </div>
                    <span class="error-text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="w-50">
              <!-- <div class="Field" style="margin-bottom: 30px">
                <span class="title">{{ this.$t("productPhotos") }}</span>
                <div class="text-field">
                  <span class="label">{{ this.$t("uploadPhoto") }}</span>
                  <label
                    for="file-upload"
                    class="custom-file-upload"
                    :class="{ disabled: isInputDisable }"
                  >
                    <span>Upload file</span>
                    <input
                      id="file-upload"
                      type="file"
                      :disabled="isInputDisable"
                      accept="image/jpeg, image/png"
                      multiple
                      @change="previewFiles"
                    />
                    <vue-icon icon="FolderIcon" class="iconUploadBtn" />
                  </label>
                </div>
                <transition-group
                  v-if="productData.photos.length"
                  tag="div"
                  name="fade"
                  class="image-preview-container"
                >
                  <div
                    v-for="(image, index) in productData.photos"
                    :key="index"
                    class="image-preview-box"
                  >
                    <img
                      v-if="image.hasOwnProperty('file')"
                      :src="image.url"
                      alt="Preview"
                    />
                    <img v-else :src="`${FILE_URL}/${image.url}`" />
                    <span
                      class="delete-icon"
                      @click="deleteImage(image, index)"
                    >
                      <vue-icon icon="deletePhoto" />
                    </span>
                  </div>
                </transition-group>
              </div> -->
              <div class="Field">
                <span class="title">{{ this.$t("productCondition") }}</span>
                <div class="container-radios">
                  <div class="radio-div">
                    <ValidationProvider rules="required">
                      <label>
                        <input
                          type="radio"
                          value="NEW"
                          v-model="productData.status"
                        />
                        {{ this.$t("NEW") }}
                      </label>
                    </ValidationProvider>
                  </div>
                  <div class="radio-div">
                    <ValidationProvider rules="required">
                      <label>
                        <input
                          type="radio"
                          v-model="productData.status"
                          value="SECOND_HAND"
                        />
                        {{ this.$t("used") }}
                      </label>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <!-- <div class="Field">
                <span class="title">{{ this.$t("type") }}</span>
                <div class="container-radios">
                  <div class="radio-div">
                    <ValidationProvider rules="required">
                      <label>
                        <input
                          type="radio"
                          value="FOR_USE"
                          v-model="productData.type"
                        />
                        {{ this.$t("foruse") }}
                      </label>
                    </ValidationProvider>
                  </div>
                  <div class="radio-div">
                    <ValidationProvider rules="required">
                      <label>
                        <input
                          type="radio"
                          v-model="productData.type"
                          value="FOR_REALIZATION"
                        />
                        {{ this.$t("forrealization") }}
                      </label>
                    </ValidationProvider>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="footer__action">
            <router-link to="/my-office">
              <button class="cancel btn">{{ this.$t("cancel") }}</button>
            </router-link>
            <v-btn
              class="add btn text-capitalize"
              :loading="isLoading"
              type="submit"
            >
              {{ this.$t("add") }}
            </v-btn>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <v-dialog v-model="dialog" max-width="400px">
      <div class="model_container">
        <span>
          <span class="title">{{ this.$t("addCategory") }}</span>
          <div @click="closeModal">
            <vue-icon
              icon="newBoldCloseIcon"
              style="cursor: pointer"
            ></vue-icon>
          </div>
        </span>
        <ValidationObserver ref="observer">
          <form @submit.prevent="handleSubmit" style="width: 100%">
            <div class="modalForm">
              <label>
                {{ this.$t("nameCategory") }} (Ру)
                <ValidationProvider
                  name="nameRu"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="nameRu"
                    :class="{ errorInput: !!errors[0] }"
                    minlength="2"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("nameCategory") }} (O’z)
                <ValidationProvider
                  name="nameUz"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="nameUz"
                    :class="{ errorInput: !!errors[0] }"
                    minlength="2"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("nameCategory") }} (Eng)
                <ValidationProvider
                  name="nameEng"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="nameEng"
                    :class="{ errorInput: !!errors[0] }"
                    minlength="2"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <v-btn type="submit" class="add btn" :loading="isLoading">
                {{ this.$t("add") }}
              </v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { debounce } from "../../../../../utils/pureFunctions";
import VueSelect from "../../../../../components/ui/vue-select/VueSelect.vue";
import { RESOURCE_URL } from "@/config";

export default {
  components: { VueSelect },
  data() {
    return {
      productData: {
        name: "",
        description: "",
        id: "",
        ownerName: "",
        deletedFiles: [],
        photos: [],
        remains: "",
        status: "",
        totalCount: null,
        type: "",
        categoryId: "",
      },
      FILE_URL: `${RESOURCE_URL}/api/file/view-image`,
      productName: "",
      description: "",
      quantity: "",
      isLoading: false,
      nameRu: "",
      nameUz: "",
      nameEng: "",
      dialog: false,
      uploadedImages: [],
      categoryList: [],
      categorySearchText: null,
      selectedOption: "NEW",
      selectedOptionForType: "FOR_USE",
      selectedCategory: null,
    };
  },
  methods: {
    submitFormProductCreate() {
      this.$refs.observerproduct.validate().then(async (success) => {
        this.isLoading = true;
        if (success) {
          const formData = new FormData();
          formData.append("name", this.productData.name);
          formData.append("id", this.productData.id);
          formData.append("description", this.productData.description);
          formData.append("count", this.productData.totalCount);
          formData.append("categoryId", this.productData.categoryId);
          formData.append("status", this.productData.status);
          formData.append("type", this.productData.type);
          formData.append("deletedFiles", this.productData.deletedFiles);
          // for (const image of this.productData.photos) {
          //   if (image.file) {
          //     formData.append("files", image.file);
          //   }
          // }

          for (const entry of formData.entries()) {
            console.log(entry[0], entry[1]);
          }

          await this.createProduct(formData);
          this.isLoading = false;
          // this.$refs.observerproduct.reset();
        }
      });
    },
    async createProduct(formData) {
      try {
        this.showLoading();
        const { data } = await this.$http.post(
          "/office-product/save",
          formData
        );

        this.productData = { ...data.data, deletedFiles: [] };
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        console.log(e);
      } finally {
        this.clearLoading();
        window.location.href = "/my-office";
      }
    },
    handleSubmit() {
      this.closeModal();
      this.$refs.observer.validate().then((result) => {
        if (result) {
          const formValues = {
            name_en: this.nameEng,
            name_ru: this.nameRu,
            name_uz: this.nameUz,
            name_uzl: this.nameUz,
            forOffice: true,
          };

          this.categoryCreate(formValues);
          this.$refs.observer.reset();
        }
      });
    },
    clearSelectedCategory(value) {
      console.log(value);
    },
    setSearchValue(value) {
      this.categorySearchText = value;
    },
    async categorySelectSearch() {
      const value = this.categorySearchText?.trim();
      if (value === "") {
        this.categorySearchText = null;
      } else {
        this.categorySearchText = value;
      }
      await this.getCategoryList();
    },
    async categoryCreate(form) {
      this.isLoading = true;
      try {
        await this.$http.post("product-type/save", form);
        this.setSuccess({ text: this.$t("successfullySaved") });
        await this.getCategoryList();
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
        this.nameEng = "";
        this.nameRu = "";
        this.nameUz = "";
      }
    },
    async getCategoryList() {
      try {
        const {
          data: { data },
        } = await this.$http.get(`product-type/list`, {
          params: {
            page: 0,
            limit: 0,
            name: this.categorySearchText,
            forOffice: true,
          },
        });
        this.categoryList = data;
      } catch (e) {
        console.log(e);
      }
    },
    // previewFiles(event) {
    //   const files = event.target.files;
    //   for (let i = 0; i < files.length; i++) {
    //     if (i >= 4) {
    //       break;
    //     }
    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //       this.productData.photos.push({
    //         url: e.target.result,
    //         file: files[i],
    //       });
    //     };
    //     reader.readAsDataURL(files[i]);
    //   }
    // },
    // deleteImage(image, index) {
    //   // eslint-disable-next-line no-prototype-builtins
    //   if (!image.hasOwnProperty("file")) {
    //     this.productData.deletedFiles.push(image.id);
    //   }
    //   this.productData.photos.splice(index, 1);
    // },
    closeModal() {
      this.dialog = false;
    },
    async getProductData() {
      const params = this.$route.params;
      try {
        const { data } = await this.$http.get(
          `office-product/get/${params.productIdEdit}`
        );

        this.productData = { ...data.data, deletedFiles: [] };
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    isInputDisable() {
      return this.uploadedImages.length >= 4;
    },
    debouncedCategorySearchByName() {
      return debounce(this.categorySelectSearch, 300);
    },
  },
  created() {
    this.getCategoryList();
    this.getProductData();
  },
};
</script>

<style lang="scss" scoped>
.errorInput {
  border-color: red;
  -webkit-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  -moz-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
}

.error-text {
  height: 10px;
  font-size: 12px;
  color: red;
  font-family: "Rubik", sans-serif;
  margin-top: 5px;
}

.main-container {
  display: flex;
  gap: 32px;
}

.w-50 {
  width: 50%;
}

.backbtn-container {
  display: flex;
  align-items: center;
  gap: 3px;
}

.back-btn {
  background-color: #fff;
  border-radius: 6px;
  display: inline-block;
  padding: 4px;
  transition: 0.4s ease;
  border: 1px solid #dfe2e9;
  box-shadow: 0px 1px 2px 0px #0e31581a;

  &:hover {
    border-color: #0096b2;
  }
}

.wrappers {
  background-color: #fff;
  border-radius: 6px;
  padding: 24px;
  margin-top: 24px;
  border-radius: 6px;
}

input,
textarea {
  background-color: #fafbfc;
  border-radius: 5px;
  border: 1px solid #dfe2e9;
  outline: none;
  padding: 6px;
}

.title {
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.09px;
  color: #303d4d;
}

input:disabled {
  cursor: not-allowed;
}

.label {
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.22px;
  text-align: left;
}

.Field {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
}

.text-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.custom-file-upload {
  display: block;
  position: relative;
}

.custom-file-upload.disabled span,
.custom-file-upload.disabled {
  cursor: not-allowed;
}

.custom-file-upload input[type="file"] {
  display: none;
}

.custom-file-upload span {
  display: block;
  padding: 6px 10px;
  background: transparent;
  border: 1px dashed #dfe2e9;
  color: #a2a5b9;
  cursor: pointer;
  border-radius: 4px;
}

.iconUploadBtn {
  position: absolute;
  right: 10px;
  bottom: 11px;
}

.image-preview-container {
  display: flex;
  flex-wrap: wrap;
}

.image-preview-box {
  position: relative;
  width: 124px;
  height: 124px;
  margin: 10px;
  border: 1px dashed #dfe2e9;
  border-radius: 5px;
  padding: 5px;
}

.image-preview-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  cursor: pointer;
  color: red;
  font-size: 16px;
}

/* Style for when hovering over the upload button */
//.custom-file-upload span:hover {
//  background: #0056b3;
//}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.radio-div {
  display: flex;
  align-items: center;
  gap: 15px;
}

.container-radios {
  display: flex;
  gap: 20px;
}

.footer__action {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #e0e0e0;
  padding-top: 14px;
}

.btn {
  padding: 6px 12px;
  border-radius: 6px;
}

.btn.cancel {
  background-color: #dfe2e9;
  color: #7a889b;
}

.btn.add {
  background-color: #0096b2;
  color: #fff;
}

.category_container {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}

.model_container {
  background-color: #fff;
  padding: 24px;

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modalForm {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: 20px;

    input {
      width: 100%;
    }
  }
}

.errorSelect .vue-select__wrap .vue-select__input {
  border: 1px solid red !important;
}
</style>
